import { AdditionalServicesRepository } from '../repositories/additional_services.repository'
import {
    AdditionalServicesTypesList,
    UpdateAdditionalServicesPayloadT,
} from '../types/additional_services.types'
const additionalServicesRepository = new AdditionalServicesRepository()

export class AdditionalServicesService {
    async getList(): Promise<AdditionalServicesTypesList> {
        const response = await additionalServicesRepository.getList()
        return response.data
    }

    async updateInvoiceAdditionalServices(
        invoice_id: number,
        payload: UpdateAdditionalServicesPayloadT
    ): Promise<void> {
        const response = await additionalServicesRepository.updateInvoiceAdditionalServices(
            invoice_id,
            payload
        )
        return response.data
    }

    async updateOrderAdditionalServices(
        order_id: number,
        payload: UpdateAdditionalServicesPayloadT
    ): Promise<void> {
        const response = await additionalServicesRepository.updateOrderAdditionalServices(
            order_id,
            payload
        )
        return response.data
    }
}
